import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import LabeledOption from '../react-labeled-option';

// No Default Prop is required here PriceWithFees will always be shown within popular filters
const PopularFilters = ({popularFilters = []}) => (
  <section className="ListingsFilter__sectionContainer">
    <h3 className="ListingsFilter__sectionContainer__Header">
      <FormattedMessage defaultMessage="Popular Filters" id="ListingsFilter.popularfilters" />
    </h3>
    {popularFilters.map((filter, index) => (
      <LabeledOption {...filter} key={`popular-filter-${index}`} typeOfInput="Toggle" />
    ))}
  </section>
);

PopularFilters.propTypes = {
  popularFilters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      selected: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
};

export default PopularFilters;
